import { Annotation, UserPrefState } from '@readcloud/data';
import React from 'react';
import { HTMLAnnotationEditor } from './HTMLAnnotation/HTMLAnnotationEditor';
import { ImageAnnotationEditor } from './ImageAnnotation/ImageAnnotationEditor';
import { MediaAnnotationEditor } from './MediaAnnotation/MediaAnnotationEditor';
import { OverlayTextAnnotationEditor } from './OverlayTextAnnotation/OverlayTextAnnotationEditor';
import { PathAnnotationEditor } from './PathAnnotation/PathAnnotationEditor';
import { ShapeAnnotationEditor } from './ShapeAnnotation/ShapeAnnotationEditor';

/**
 * Responsible for editing any type of annotation - just a switch statement really
 */
export const AnnotationEditor = React.memo(function AnnotationEditor(props: {
  annotation: Annotation;
  onChange: (annotation: Annotation) => void;
  submitLabel?: string;
  onCancel?: () => void;
  autoSubmit?: boolean;
  showPublisherOptions: boolean;
  onSavePreferences?: (type: string, data: Partial<Annotation['data']>) => void;
  annoPrefs?: UserPrefState['annoPrefs'];
}) {
  switch (props.annotation?.type) {
    case 'Image':
      return (
        <ImageAnnotationEditor
          showPublisherOptions={props.showPublisherOptions}
          autoSubmit={props.autoSubmit}
          annotation={props.annotation}
          onChange={props.onChange}
          submitLabel={props.submitLabel}
          onCancel={props.onCancel}
          onSavePreferences={props.onSavePreferences}
          annoPrefs={props.annoPrefs}
        />
      );
    case 'Media':
      return (
        <MediaAnnotationEditor
          showPublisherOptions={props.showPublisherOptions}
          autoSubmit={props.autoSubmit}
          annotation={props.annotation}
          onChange={props.onChange}
          submitLabel={props.submitLabel}
          onCancel={props.onCancel}
        />
      );
    case 'HTML':
      return (
        <HTMLAnnotationEditor
          showPublisherOptions={props.showPublisherOptions}
          autoSubmit={props.autoSubmit}
          annotation={props.annotation}
          onChange={props.onChange}
          submitLabel={props.submitLabel}
          onCancel={props.onCancel}
        />
      );
    case 'Circle':
    case 'Rectangle':
      return (
        <ShapeAnnotationEditor
          disableStroke={false}
          showPublisherOptions={props.showPublisherOptions}
          autoSubmit={props.autoSubmit}
          annotation={props.annotation}
          onChange={props.onChange}
          submitLabel={props.submitLabel}
          onCancel={props.onCancel}
          onSavePreferences={props.onSavePreferences}
          annoPrefs={props.annoPrefs}
        />
      );

    case 'OverlayText':
      return (
        <OverlayTextAnnotationEditor
          showPublisherOptions={props.showPublisherOptions}
          autoSubmit={props.autoSubmit}
          annotation={props.annotation}
          onChange={props.onChange}
          submitLabel={props.submitLabel}
          onCancel={props.onCancel}
          onSavePreferences={props.onSavePreferences}
          annoPrefs={props.annoPrefs}
        />
      );
    case 'Path':
      return (
        <PathAnnotationEditor
          showPublisherOptions={props.showPublisherOptions}
          autoSubmit={props.autoSubmit}
          annotation={props.annotation}
          onChange={props.onChange}
          submitLabel={props.submitLabel}
          onCancel={props.onCancel}
          onSavePreferences={props.onSavePreferences}
          annoPrefs={props.annoPrefs}
        />
      );
  }
});
